module.exports = __webpack_public_path__ + "static/media/active_sites_ico.ae2ec2bf.svg";